export function formatDevicesLabel(count) {
    if (count === 1) return 'устройство';
    if (count >= 2 && count <= 4) return 'устройства';
    return 'устройств';
}

/**
 * @param {unknown} response
 * @returns {{ options: number[], map: Map<number, object> }}
 */
export function parsePricingResponse(response) {
    if (!response || typeof response !== 'object') {
        throw new Error('Некорректный ответ pricing');
    }

    const prices = response.prices;
    if (!Array.isArray(prices) || prices.length === 0) {
        throw new Error('Pricing не содержит доступных цен');
    }

    const map = new Map();
    const options = [];

    for (const item of prices) {
        const devices = Number(item?.devices);
        const monthlyPrice = Number(item?.monthly_price);

        if (!Number.isInteger(devices) || devices <= 0) {
            throw new Error('Некорректное количество устройств в pricing');
        }

        if (!Number.isFinite(monthlyPrice) || monthlyPrice < 0) {
            throw new Error('Некорректная цена в pricing');
        }

        if (map.has(devices)) {
            throw new Error('Дублирующийся tier в pricing');
        }

        map.set(devices, {
            devices,
            monthly_price: Math.round(monthlyPrice),
            savings_amount: normalizeOptionalNumber(item.savings_amount),
            savings_percent: normalizeOptionalNumber(item.savings_percent),
        });
        options.push(devices);
    }

    options.sort((left, right) => left - right);

    return { options, map };
}

function normalizeOptionalNumber(value) {
    if (value == null || value === '') {
        return undefined;
    }

    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : undefined;
}

/**
 * @param {number} devices
 * @param {{ map: Map<number, object> }} parsed
 * @returns {number | null}
 */
export function getPrice(devices, parsed) {
    const item = parsed.map.get(devices);
    return item?.monthly_price ?? null;
}

/**
 * @param {number} devices
 * @param {{ map: Map<number, object> }} parsed
 * @returns {object | null}
 */
export function getPriceItem(devices, parsed) {
    return parsed.map.get(devices) ?? null;
}
